export default function DSA_Merge_Sort() {
  return <div>DSA_Merge_Sort Component</div>;
}
